import { StatusDefinition, allowedStatuses } from './Status'

export interface DeductionCreatePayload {
    userId: string
    amount: number
    currencyId: string
    deductionType: string
    remarks: string
    referenceType: string | undefined
    reference: string | undefined
}

export interface DeductionUpdatePayload {
    deductionId: string
    accountId: string
    status: string
}

export interface DeductionRetrieve {
    status: string
    id: string
    remarks?: string
    accountId?: string
}

export default class Deduction {
    static journey = ['pending', 'completed']

    static hints: Record<string, string> = {
        pending: 'Waiting for a decision',
        completed: 'The amount is taken from the balance',
        failed: 'Cancelled, nothing is taken',
    }

    // A deduction can only change while it is pending
    static statuses(deduction: { status: string }): StatusDefinition[] {
        const statuses: Array<StatusDefinition> = [
            {
                value: 'pending',
                description: 'Pending',
                available: [],
            },
            {
                value: 'completed',
                description: 'Completed',
                available: ['pending'],
            },
            {
                value: 'failed',
                description: 'Failed',
                available: ['pending'],
            },
        ]

        return allowedStatuses(statuses, deduction.status)
    }
}
